import { SheetView } from '@/app/prepare-chat/views/sheet/sheet-view'
import { DisplayManagement } from '@/components/DisplayManagement'
import { Toolbar } from '@/components/Toolbar/toolbar'
import { SheetThemeProvider } from '@/contexts/SheetThemeContext'
import { memo } from 'react'
import { SheetViewContainerProps } from '../../types'

export const MemoizedSheetViewContainer = memo(function SheetViewContainer({
  sourceSheetId,
  fileId,
  isSidebarCollapsed,
  handleSidebarCollapse,
  setShowEnrichment,
  showEnrichment,
  onEnrichmentEdit,
  setShowRules,
  showRules,
  onRuleEdit,
}: SheetViewContainerProps) {
  return (
    <SheetThemeProvider>
      <div className='flex flex-col bg-white h-full overflow-hidden basis-1000 flex-grow'>
        <Toolbar
          sheetId={sourceSheetId}
          isSidebarCollapsed={isSidebarCollapsed}
          handleSidebarCollapse={handleSidebarCollapse}
          setShowEnrichment={setShowEnrichment}
          showEnrichment={showEnrichment}
          commitCurrentChanges={() => {}}
          onEnrichmentEdit={onEnrichmentEdit}
          setShowRules={setShowRules}
          showRules={showRules}
          onRuleEdit={onRuleEdit}
        />
        <div className='flex-1 overflow-auto relative'>
          <div className='absolute top-[0] right-[-1px] z-20'>
            <DisplayManagement sheetId={sourceSheetId} />
          </div>
          <SheetView
            sourceSheetId={sourceSheetId}
            fileId={fileId}
            setShowEnrichment={setShowEnrichment}
            showEnrichment={showEnrichment}
          />
        </div>
      </div>
    </SheetThemeProvider>
  )
})
